import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarModule } from '@shared/shared/sidebar/sidebar/sidebar.module';
import { BrowserDrawerComponent } from '@shared/shared/drawers/browser/browser-drawers/internal/browser-drawer/browser-drawer.component';
import { StringTemplateOutletModule } from '@shared/ui/kit/string-template-outlet/string-template-outlet.module';
import { DrawerDataToAnimationParamsPipe } from '@shared/shared/drawers/browser/browser-drawers/internal/browser-drawer/drawer-data-to-animation-params.pipe';
import { DrawerDataToClassListPipe } from '@shared/shared/drawers/browser/browser-drawers/internal/browser-drawer/drawer-data-to-class-list.pipe';
import { ComponentRendererModule } from '@shared/ui/component-renderer/component-renderer.module';

@NgModule({
  declarations: [BrowserDrawerComponent, DrawerDataToAnimationParamsPipe, DrawerDataToClassListPipe],
  imports: [CommonModule, StringTemplateOutletModule, ComponentRendererModule],
  exports: [BrowserDrawerComponent]
})
export class BrowserDrawerComponentModule {}
